import gql from 'graphql-tag';

export const COMPUTE_GRADING = gql`
  mutation ($applicationId: String!) {
    recomputeDSRCGrading(applicationId: $applicationId) {
      firstDegreeUniversityRanking
      firstDegreeGPAOrClassRanking
      publicationAndMerit
      departmentInput
      bonus
      total
    }
  }
`;

export const GET_GRADING = gql`
  query ($applicationId: String!) {
    queryDSRCGrading(applicationId: $applicationId) {
      firstDegreeUniversityRanking
      firstDegreeGPAOrClassRanking
      publicationAndMerit
      departmentInput
      bonus
      total
    }
  }
`;
